import API from "@/Api";

import "./style.css";

export default class SearchBox {
  static selector = ".search-box";

  constructor(block) {
    this.block = block;

    this.loadingMessage = this.block.querySelector(
      ".search-box__loading-message"
    );
    this.noResultsMessage = this.block.querySelector(
      ".search-box__no-results-message"
    );
    this.resultsContainer = this.block.querySelector(".search-box__results");
    this.resultsItemTemplate = this.block.querySelector(
      ".search-box__results-item-template"
    );

    this.isLoading = false;
    this.isOpen = false;
  }

  showLoadingMessage = () => {
    this.block.classList.add("search-box--loading");
    this.block.classList.remove("search-box--no-results");
  };
  hideLoadingMessage = () => {
    this.block.classList.remove("search-box--loading");
  };
  showNoResultsMessage = () => {
    this.block.classList.add("search-box--no-results");
    this.block.classList.remove("search-box--loading");
  };

  renderResult = result => {
    // clone from template
    const resultItem = this.resultsItemTemplate.content.cloneNode(true);

    // find container elements
    const dateElement = resultItem.querySelector(
      ".search-card__head__date-value"
    );
    const authorsContainerElement = resultItem.querySelector(
      ".search-card__head__img-author"
    );
    const titleElement = resultItem.querySelector(".search-card__title a");
    const tagsContainerElement = resultItem.querySelector(".tags-list__inner");

    // get result data
    const { date, title, authors, type, url } = result;

    // add data to elements
    dateElement.innerText = date;

    // add authors pictures
    authors.forEach(({ name, picture }) => {
      const authorElement = document.createElement("img");

      authorElement.src = picture;
      authorElement.alt = name;

      authorsContainerElement.appendChild(authorElement);
    });

    // add title
    titleElement.innerText = title;
    titleElement.href = result.url;

    // add tag (post type)
    const tagElement = document.createElement("li");
    tagElement.classList.add(
      "tags-list__tag",
      "tags-list__tag--red-transparent"
    );
    const tagBoxElement = document.createElement("span");
    tagBoxElement.classList.add("tag-box");
    tagBoxElement.innerText = type.charAt(0).toUpperCase() + type.slice(1);
    tagElement.appendChild(tagBoxElement);
    tagsContainerElement.appendChild(tagElement);

    // append to results container
    this.resultsContainer.appendChild(resultItem);
  };

  open = () => {
    if (this.isOpen) {
      return;
    }

    this.isOpen = true;

    document.body.classList.add("search-box-open");
  };
  close = () => {
    if (!this.isOpen) {
      return;
    }

    document.body.classList.remove("search-box-open");

    this.resultsContainer.innerHTML = "";

    this.isOpen = false;
  };

  search = async query => {
    this.isLoading = true;

    this.showLoadingMessage();

    if (!this.isOpen) {
      this.open();
    }

    const results = await API.searchResults(query);

    // empty results container
    this.resultsContainer.innerHTML = "";

    if (results.length === 0) {
      this.showNoResultsMessage();
      return;
    }

    // fill results container
    results.forEach(this.renderResult);

    this.isLoading = false;
    this.hideLoadingMessage();
  };

  onReady = () => {};
  onDestroy = () => {};
}
